// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ImageSvg from '@rsuite/icon-font/lib/av/Image';
var Image = createSvgIcon({
  as: ImageSvg,
  ariaLabel: 'image',
  category: 'av',
  displayName: 'Image'
});
export default Image;